import { supabase } from "@/lib/supabase/browser-client"
import { BaseSubscriptionManager } from "./base-subscription-manager";

class ClientSubscriptionManager extends BaseSubscriptionManager {
 private constructor() {
	super(supabase, `lib.clientSubscriptionMgr/${Date.now()}`)
 }
}

declare global {
 var clientSubscriptionManager: ClientSubscriptionManager | undefined
}

export function getClientSubscriptionManager() {
 if (typeof window === 'undefined') {
  throw new Error('ClientSubscriptionManager can only be used on the client')
 }
 if (!globalThis.clientSubscriptionManager) {
	// @ts-ignore
  globalThis.clientSubscriptionManager = new ClientSubscriptionManager()
 }
 return globalThis.clientSubscriptionManager!
}